import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export function decimalHoursToHHMM(decimalHours) {
  const totalMinutes = decimalHours * 60;
  const dur = dayjs.duration(totalMinutes, "minutes");
  let hours = Math.floor(dur.asHours());
  let minutes = dur.minutes();
  const seconds = dur.seconds();
  if (seconds > 29) {
    minutes += 1;
    if (minutes === 60) {
      hours += 1;
      minutes = 0;
    }
  }
  return `${hours}h ${minutes}m`;
}

export function dayjsFromDecimalHours(value) {
  if (value == null || value === 0) {
    return dayjs("00:00", "HH:mm"); // explicitly create 00:00
  }
  const hours = Math.floor(value);
  const minutes = Math.round((value - hours) * 60);
  return dayjs().startOf("day").add(hours, "hour").add(minutes, "minute");
}
